<template>
    <div>
        <card-header icon="fa-message-check">
            <template #title>
                Recent Requests/Activity
            </template>
        </card-header>

        <card-body>
            <card-list>
                <account-request-tile
                    v-for="r in requests"
                    :key="r.id"
                    :request="r"
                    :card="card"
                    @click="openRequest(r)"
                />
            </card-list>
        </card-body>

        <card-footer>
            {{ requests.length }} recent requests (5 days)
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import CardFooter from "@/TIER/components/CardFooter";
    import AccountRequestTile from "../../components/tiles/AccountRequestTile";

    import {client as http} from '@/http_client';

    export default {
        components: {AccountRequestTile, CardFooter, CardList, CardBody, CardHeader},
        props: ['card', 'props', 'child'],
        data() {
            return {
                requests: []
            };
        },
        methods: {
            load: function() {
                this.$emit('loading', true);
                http.get('payment-plans/recent-requests', {force: true}).then(response => {
                    this.requests = response.data;
                    this.$emit('loading', false);
                }).catch(err => {
                    console.log(err);
                    this.$emit('loading', false);
                });
            },
            openRequest: function(r) {
                if (r.plan_id) {
                    this.$openCard('payment-plan', {planId: r.plan_id}, this.card);
                } else if (r.user_id) {
                    this.$openCard('user', {userId: r.user_id}, this.card);
                }
            },
            reload: function() {
                this.load();
            }
        },
        mounted() {
            this.load();
        }
    };
</script>
